module.exports = __webpack_public_path__ + "img/piattaformadefault.47c19db4.png";